/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CanRecordResult {
    Error = 0,
    Ok = 1,
    TrainingSessionMissing = 2,
    TrainingSessionNeedContinue = 3,
    RecorderHasOtherActiveRecording = 4,
    RecordingHasOtherActiveRecorder = 5,
    RecordingIsPreparedByOtherActiveRecorder = 6,
}
